import clsx from 'clsx';
import React, { useContext } from 'react';
import { CommonSeparator } from './CommonSeparator';
import { BoxContext } from './Context';
import { BoxVariant } from './types';

export const Separator: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { variant } = useContext(BoxContext);
  return <CommonSeparator line={<Line variant={variant} />}>{children}</CommonSeparator>;
};

const Line: React.FC<React.PropsWithChildren<{ variant: BoxVariant }>> = ({
  children,
  variant,
}) => {
  return (
    <div
      className={clsx(
        'w-full border-t',
        variant === 'filled' ? 'border-primary opacity-50' : 'border-gray-100 opacity-100'
      )}
    >
      {children}
    </div>
  );
};
